import { useEffect, useState } from "react";
import { api } from "../api/client";
import { formatSol, solToLamports } from "../overlay/format";
import { useWalletAction } from "../overlay/useWalletAction";
import { t } from "../strings";
import { useWallet } from "../wallet/WalletProvider";
import { ActionStatus } from "./ActionStatus";

/**
 * Registration (§7.1): POST /players/register → wallet signs the GA-partially-signed
 * legacy transaction → /players/register/submit.
 */
export function RegisterStep({ onDone }: { onDone: () => void }) {
  const { markRegistered } = useWallet();
  const action = useWalletAction();
  const [suggested, setSuggested] = useState<string | null>(null);
  const [sol, setSol] = useState("");
  const [inputError, setInputError] = useState<string | null>(null);

  useEffect(() => {
    api
      .register("0")
      .then((r) => {
        if (r.suggestedVaultLamports) {
          setSuggested(r.suggestedVaultLamports);
          setSol(formatSol(r.suggestedVaultLamports));
        }
      })
      .catch(() => {});
  }, []);

  const submit = async () => {
    setInputError(null);
    let lamports: string;
    try {
      lamports = sol ? solToLamports(sol) : "0";
    } catch (e) {
      setInputError((e as Error).message);
      return;
    }
    const r = await action.run(() => api.register(lamports), "register");
    if (r) {
      markRegistered();
      onDone();
    }
  };

  return (
    <div className="card">
      <h2>Create your trainer account</h2>
      <p>
        Registering creates your on-chain player account. Your wallet pays small refundable deposits once. The vault holds SOL for your Pokémon's storage
        deposits; you can add more or withdraw any time no save is in flight.
      </p>
      <label>
        Initial vault (SOL){suggested && <span className="hint"> — suggested {formatSol(suggested)} SOL for about an hour of play</span>}
        <input inputMode="decimal" value={sol} onChange={(e) => setSol(e.target.value)} />
      </label>
      <p className="banner warn">{t.lostWallet}</p>
      <button disabled={action.busy} onClick={submit}>
        Register
      </button>
      {inputError && <p className="status error">{inputError}</p>}
      <ActionStatus {...action} />
    </div>
  );
}
